export default __webpack_public_path__ + "static/ACP-CA-15a9de8b9999879ab6edeeb2a7f4c0bb.svg";